import React from 'react';
import { UseFormRegister, FieldErrors } from 'react-hook-form';
import { DeliveryNote } from '../../../types';
import Input from '../Input';
import Select from '../Select';

interface WorkSiteVesselSectionProps {
  register: UseFormRegister<DeliveryNote>;
  errors: FieldErrors<DeliveryNote>;
  vesselOptions: { value: string; label: string }[];
}

const WorkSiteVesselSection: React.FC<WorkSiteVesselSectionProps> = ({
  register,
  errors,
  vesselOptions,
}) => {
  return (
    <div className="card">
      <div className="card-header">
        <h2 className="text-lg font-semibold text-gray-900">Work Site & Vessel Information</h2>
      </div>
      <div className="card-body">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <Input
              label="Work Site / Vessel"
              {...register('workSite', { required: 'Work site is required' })}
              error={errors.workSite?.message}
              placeholder="Work site or vessel name"
            />
          </div>
          <div>
            <Input
              label="Date"
              type="date"
              {...register('date', { required: 'Date is required' })}
              error={errors.date?.message}
            />
          </div>
          <div>
            <Input
              label="Project / Location"
              {...register('projectLocation', { required: 'Project location is required' })}
              error={errors.projectLocation?.message}
              placeholder="Project location"
            />
          </div>
          <div>
            <Input
              label="Note No."
              {...register('noteNo')}
              placeholder="Note number (optional)"
            />
          </div>
          <div>
            <Select
              label="Vessel"
              {...register('vessel', { required: 'Vessel is required' })}
              options={vesselOptions}
              error={errors.vessel?.message}
            />
          </div>
          <div>
            <Input
              label="Delivery Date"
              type="date"
              {...register('deliveryDate', { required: 'Delivery date is required' })}
              error={errors.deliveryDate?.message}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkSiteVesselSection;
